import { render, staticRenderFns } from "./BaseProductConfigurations.vue?vue&type=template&id=277ed689&scoped=true"
import script from "./BaseProductConfigurations.vue?vue&type=script&lang=js"
export * from "./BaseProductConfigurations.vue?vue&type=script&lang=js"
import style0 from "./BaseProductConfigurations.vue?vue&type=style&index=0&id=277ed689&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277ed689",
  null
  
)

export default component.exports